export const AUTH = 'AUTH';

export const LOGOUT = 'LOGOUT';

export const USER_SIGNIN = 'USER_SIGNIN';
export const USER_SIGNUP = 'USER_SIGNUP';
export const AUTH_FAIL = 'AUTH_FAIL';

export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

/*  THIS FOR DATA AND UPDATE ME ONLY */
export const USERUPDATE__SUCCESS = 'USERUPDATE__SUCCESS';
export const USERUPDATE__FAIL = 'USERUPDATE__FAIL';
/*  THIS FOR DATA AND UPDATE ME ONLY */
export const UPDATEPASS_SUCCESS = 'UPDATEPASS_SUCCESS';
export const UPDATEPASS_FAIL = 'UPDATEPASS_FAIL';

/*  THIS FOR GET ALL USERS FRO ADMIN */
export const USERS_DATA_SUCCES = 'USERS_DATA_SUCCES';
export const USERS_DATA_FAIL = 'USERS_DATA_FAIL';

/*  THIS GET USER BY ID */
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const GET_USER_DATA_FAIL = 'GET_USER_DATA_FAIL';

/*  THIS UPDATE USER BY ID */
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';

/* DELETE USER BY ID */
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';

/* USERS FILTER ADMIN */
export const GET_ACTIVE_USERS = 'GET_ACTIVE_USERS';


/* TOURS */
export const GET_ALL_TOURS_SUCCESS = 'GET_ALL_TOURS_SUCCESS';
export const GET_ALL_TOURS_FAIL = 'GET_ALL_TOURS_FAIL';
export const GET_TOUR_DATA_SUCCESS = 'GET_TOUR_DATA_SUCCESS';
export const GET_TOUR_DATA_FAIL = 'GET_TOUR_DATA_FAIL';

/* BOOKING */
export const CREATE_BOOKING_SUCCESS = 'CREATE_BOOKING_SUCCESS';
export const CREATE_BOOKING_FAIL = 'CREATE_BOOKING_FAIL';
export const GET_BOOKING_SUCCESS = 'GET_BOOKING_SUCCESS';
export const GET_BOOKING_FAIL = 'GET_BOOKING_FAIL';
export const GETALL_BOOKINGS_SUCCESS = 'GETALL_BOOKINGS_SUCCESS';
export const GETALL_BOOKINGS_FAIL = 'GETALL_BOOKINGS_FAIL';
export const DELETE_BOOKING_SUCCESS = 'DELETE_BOOKING_SUCCESS';
export const DELETE_BOOKING_FAIL = 'DELETE_BOOKING_FAIL';

export const ADD_RATING_SUCCESS = 'ADD_RATING_SUCCESS';
export const ADD_RATING_FAIL = 'ADD_RATING_FAIL';
export const GET_RATING_SUCCESS = 'GET_RATING_SUCCESS';
export const GET_RATING_FAIL = 'GET_RATING_FAIL';
